/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryPredicateGroupOperator
 * Singular queries[].filter group operator (string token).
 */
export default Object.freeze({
  And: 'and',
  Or: 'or',
});
